'use client'

import dynamic from 'next/dynamic'

const FlowOnboard = dynamic(
  () =>
    import('@/components/layout/flow-onboard/index').then(
      (mod) => mod.FlowOnboard
    ),
  {
    ssr: false,
  }
)

const PopupSetting = dynamic(
  () =>
    import('@/components/layout/popup-setting/index').then(
      (mod) => mod.PopupSetting
    ),
  {
    ssr: false,
  }
)

const ReferFriend = dynamic(
  () =>
    import('@/components/layout/refer-friend/index').then(
      (mod) => mod.ReferFriend
    ),
  {
    ssr: false,
  }
)

export const PopupFirstLoad = () => {
  return (
    <>
      <FlowOnboard />
      <PopupSetting />
      <ReferFriend />
    </>
  )
}
